import styles from "./HeaderNavigation.module.scss";
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const HeaderNavigationComponent = () => {
    const { t, i18n } = useTranslation('translation');
    const navigate = useNavigate();

    return (
        <div className={styles.navigate_buttons}>
            <div className={styles.login}>
                {t("loginForm.login")}
            </div>
            <Link to="/register" className={styles.register}>
                {t("loginForm.register")}
            </Link>
        </div>
    )
}
export default HeaderNavigationComponent